import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSection.css";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate("/product");
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="left-content">
          <h2 className="title">
            CANDY <br /> TOYS
          </h2>
        </div>

        <div className="right-content">
          <p className="tagline">
            Tasty Treats & Tiny Treasures- <br />
            Made Just For You!
          </p>
        </div>

        <div className="explore-button-container">
          <button className="cta-button" onClick={handleExploreClick}>
            Explore
          </button>
        </div>

        <Shape svgPath={shape1} color="#FF6347" className="hero-shape1" />
        <Shape svgPath={shape2} color="#FFD700" className="hero-shape2" />
        <Shape svgPath={shape3} color="#8A2BE2" className="hero-shape3" />
      </div>
    </section>
  );
};

export default HeroSection;
